import styled from 'styled-components';


export const ClientFullName = styled.div`
  word-break: break-word;
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
  margin-top: 5px;
`;

export const ClientFeedback = styled.div`
  font-style: italic;
  font-size: 12px;
  line-height: 15px;
  max-width: 400px;
  margin-top: 5px;
  color: ${({ theme }) => theme.colors.secondaryDark};
`;

export const StatusWrapper = styled.div`
  display: flex;
  margin-top: 5px;
  height: min-content;
  align-items: center;

  & > span {
    margin-left: 6px;
    font-size: 12px;
    line-height: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/feedbacks/feedback/styles.js